import { namespacer } from 'helpers'

const namespace = namespacer('DASHBOARD')
export const LOAD_UPCOMING_WEBINARS_SUCCESS = namespace('LOAD_UPCOMING_WEBINARS_SUCCESS')
export const LOAD_CURRENT_USER_WEBINARS_SUCCESS = namespace('LOAD_CURRENT_USER_WEBINARS_SUCCESS')
export const SEND_CONFIRMATION_EMAIL_REQUEST = namespace('SEND_CONFIRMATION_EMAIL_REQUEST')
export const SEND_CONFIRMATION_EMAIL_SUCCESS = namespace('SEND_CONFIRMATION_EMAIL_SUCCESS')
export const SEND_CONFIRMATION_EMAIL_FAIL = namespace('SEND_CONFIRMATION_EMAIL_FAIL')
